/**
 * GNK Task Code Generator
 * Generates unique, memorable, shareable task codes.
 * Format: GNK-WORD-XXXX  (e.g. GNK-NOVA-8K3R)
 *
 * The word component comes from a curated library of energetic, techy words.
 * The suffix is a 4-char alphanumeric (base-36 from timestamp + random).
 * Combined, this gives millions of unique codes with near-zero collision risk.
 */

const WORD_LIBRARY = [
  'NOVA', 'FLUX', 'VOLT', 'APEX', 'BEAM', 'BOLT', 'CORE', 'DASH',
  'EDGE', 'FUSE', 'GLOW', 'HALO', 'IRIS', 'JADE', 'KILO', 'LYNX',
  'MARS', 'NEON', 'ONYX', 'PEAK', 'QUAD', 'RIFT', 'STAR', 'TIDE',
  'UNIT', 'VIBE', 'WAVE', 'XRAY', 'YETI', 'ZERO', 'BLZE', 'CRUX',
  'DUSK', 'ECHO', 'FIRE', 'GRID', 'HAWK', 'ICON', 'JAZZ', 'KUBO',
  'LAVA', 'MIST', 'NANO', 'OPAL', 'PROX', 'QUIX', 'RUNE', 'SAGE',
  'TRON', 'UMBR', 'VORT', 'WARP', 'XENO', 'YOKE', 'ZINC', 'ARIA',
  'BYTE', 'CODA', 'DOME', 'ENVY', 'FORK', 'GRIT', 'HIVE', 'IDEA',
  'JUMP', 'KNOT', 'LINK', 'MAZE', 'NODE', 'ORBI', 'PIXL', 'QUIL',
  'RUSH', 'SKYE', 'TUSK', 'URGE', 'VINE', 'WISH', 'XIPH', 'YARN',
  'ZEST', 'ATOM', 'BLIP', 'CHIP', 'DART', 'FERN', 'GYRO', 'HELM',
  'ISLE', 'JINX', 'KITE', 'LOOP', 'MYTH', 'NEST', 'OPUS', 'PLEX',
];

const ALPHANUMERIC = '0123456789ABCDEFGHJKLMNPQRSTUVWXYZ';

function randomChar(): string {
  return ALPHANUMERIC[Math.floor(Math.random() * ALPHANUMERIC.length)];
}

export function generateTaskCode(): string {
  const word = WORD_LIBRARY[Math.floor(Math.random() * WORD_LIBRARY.length)];
  const suffix = randomChar() + randomChar() + randomChar() + randomChar();
  return `GNK-${word}-${suffix}`;
}

/**
 * Validate a string looks like a GNK task code.
 * Accepts with or without the GNK- prefix.
 */
export function isValidTaskCode(input: string): boolean {
  const normalized = input.trim().toUpperCase();
  return /^(GNK-)?[A-Z]{4}-[A-Z0-9]{4}$/.test(normalized);
}

/**
 * Normalize user input to the canonical GNK-XXXX-XXXX format.
 */
export function normalizeTaskCode(input: string): string {
  const clean = input.trim().toUpperCase();
  if (clean.startsWith('GNK-')) return clean;
  return `GNK-${clean}`;
}
